import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import translate from '../../../../../commonComponents/translate';
import AmColumnAndLineChart from '../../../../../commonComponents/charts/AmColumnAndLineChart';
import { formatVA } from '../../../../../services/utilityFunctions';
import Notifications from '../../../../../services/notifications';

function VAPerTier({ t, userId, apiHeaders, dateStart, dateEnd }) {
  const [data, setData] = useState([]);

  const fetchData = useCallback(() => {
    if (!userId) return;
    axios
      .get(`/api/tailor-made/pureliink/career/${userId}/va-per-tier`, {
        params: { dateStart, dateEnd },
        headers: apiHeaders,
      })
      .then(({ data: response }) => {
        setData(response.data || []);
      })
      .catch(err => {
        Notifications.showErrorFromRequest(err, 'error_vaPerTier');
      });
  }, [userId, apiHeaders, dateStart, dateEnd]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (!data || data.length === 0) return null;

  const chartData = data.map(item => ({
    label: `${t('pureliink.career.simulator.rank')} ${item.tier}`,
    va: item.va ?? 0,
  }));

  const totalVA = data.reduce((sum, item) => sum + (item.va ?? 0), 0);

  return (
    <div className="pureliink-chart-card">
      <h4 className="career-section-title">
        {t('pureliink.career.simulator.vaByRank')}
      </h4>
      <p className="hint-text">
        {t('pureliink.career.simulator.vaByRankHint')}
      </p>

      <AmColumnAndLineChart
        chartId="pureliink-va-per-tier"
        containerClass="m-chart-container"
        type="columnAndLine"
        stats={chartData}
        options={{
          category: 'label',
          yLabel: 'VA',
          columnValueKey: 'va',
          columnSeriesName: 'VA',
        }}
      />

      <div className="table-responsive mt-3">
        <table className="table table-striped m-table">
          <thead>
            <tr>
              <th>{t('pureliink.career.simulator.rank')}</th>
              <th>{t('pureliink.career.simulator.va')}</th>
              <th>{t('pureliink.career.simulator.percentOfTotal')}</th>
            </tr>
          </thead>
          <tbody>
            {data.map(item => {
              const pct =
                totalVA > 0
                  ? (((item.va ?? 0) / totalVA) * 100).toFixed(1)
                  : '0.0';
              return (
                <tr key={item.tier}>
                  <td>Tier {item.tier}</td>
                  <td className="va-tier-value">{formatVA(item.va)}</td>
                  <td className="va-tier-pct">{pct}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

VAPerTier.propTypes = {
  t: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  apiHeaders: PropTypes.shape({}).isRequired,
  dateStart: PropTypes.number.isRequired,
  dateEnd: PropTypes.number.isRequired,
};

export default translate(VAPerTier);
